/**
 * Indexed DB Configuration
 * This will have function for holes website collection
 * and holes cron job collection
 * 
 * Job db and Holes db are seprated for each managing
 */
 import Localbase from 'localbase'
 import Helper from './helper';
 import { openDB} from 'idb';
 
 
 /**
  * Indexeddb version and store names
  */
 
 const version = 5;
 const dbname  = 'holesadmin';
 const stores  = [
     {
         name   : 'user',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'flavors',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'boxes',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'orders',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'settings',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'employees',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'unassignedorders',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'assignedorders',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'employerhistory',
         indexes: [],
         keypath: 'id'
     },
     {
         name   : 'employeeshistory',
         indexes: [],
         keypath: 'id'
     }
 
 ]
 
 /**
  * Create indexeddb stractures
  */
 const dbpromise = openDB(dbname, version, {
     upgrade(db) {
         stores.forEach(store => {
             /**
             * Check if store is existing or not 
             * if exist delete to create new update
             * create indexes
             */
            if(db.objectStoreNames.contains(store.name)) {
                console.log('delete store name')
                db.deleteObjectStore(store.name);
            }

            const objstore = db.createObjectStore(store.name, {keyPath : store.keypath});
            
            store.indexes.forEach(idx => {
                objstore.createIndex(idx, idx, { unique: false });
            })
         })
     },
 });
 
 // let holesdb   = new Localbase('holes');
 let holescron = new Localbase('holescron');
 
 
 /**
  * 
  * @param {String} storename // collection name 
  * @param {String} mode // readonly or readwrite
  */
 const createtransaction = async (storename, mode) => {
     const tx =  (await dbpromise).transaction(storename, mode).objectStore(storename);
 
     return tx;
 }
 
 /**
  * Adding new job this will run through
  * @param {String} url  api url
  * @param {String} method  request type (GET, POST, PUT, DELETE)
  * @param {String} params requrest body  
  * @param {String} callback function that will run after success call
  */
 const newJob = ({
         url      = '',
         method   = 'get',
         params   = {},
         callback = function() {}
     }) => {
     /**
      * Check if job is already exist
      */
     holescron.collection('jobs')
     .doc({url : url})
     .get({ keys: true })
     .then(job => {
         if(!job) {
             holescron.collection('jobs').add({
                 url     : url,
                 method  : method,
                 params  : params,
                 callback: JSON.stringify(callback, Helper.serialize)
             });
         }
     })
 }
 
 /**
  * Get all jobs documents
  * @returns job collections
  */
 const getJobs = () => {
     const jobs = new Promise((resolve, reject) => {
         holescron.collection('jobs')
             .get({ keys: true })
             .then(res => {
                 resolve(res)
             })
             .catch(err => reject(err));
     });
 
     return jobs;
 }
 
 /**
  * Get sigle document from job
  * @param {Object} filter @example {url : url}
  * @returns {Object}
  */
 const getJob = (filter) => {
     const getjob = new Promise((resolve, reject) => {
         holescron.collection('jobs')
             .doc(filter)
             .then(res => {
                 resolve(res)
             })
             .catch(err => reject(err));
     })
 
     return getjob;
 } 
 
 /**
  * Delete a job from collection documents
  * @param {Object} filter 
  */
 const deleteJob = (filter) => {
     holescron.collection('jobs')
         .doc(filter)
         .delete()
 }
 
 /**
  * Holes indexed db functions
  * @param {String} name // name of the collection to fetch
  * @param {Object} filter // (optional) property name  you want to filter and return
  * Filter properties will be {Key : <property name>, value : <value you want to filter>}
  * @returns {Array} 
  */
 const getCollections = async ({name, filter = null}) => {
     
 
     let tx = await createtransaction(name, 'readonly');
     
     const res = await tx.getAll().catch((err) => err);
 
     if(!Array.isArray(res) && res.toString().indexOf('object stores was not found')) {
         return [];
     } else {
 
         if(filter) {
             return res.filter(c => c[filter.keys] == filter.value);
         } else {
             return res;
         }
 
     }
 
 
 }
 /**
  * 
  * @param {String} name collection name 
  * @param {Object} filter @example {id : user.id}
  * @returns {Object}
  */
 const getCollection = async ({name, filter}) => {
     const tx =  await createtransaction(name, 'readonly')
     return tx.get(filter.id);
 
     // const collection = new Promise((resolve, reject) => {
     //     holesdb.collection(name)
     //         .doc(filter)
     //         .get({keys : true})
     //         .then(res => {
     //             resolve(res);
     //         })
     //         .catch(err => reject(err))
     // })
 
     // return collection
 }
 
 /**
  * Add or update collection
  * update first if the document exist
  * if faild it wil add 
  * @param {String} name 
  * @param {Object} filter 
  * @param {Object} data 
  * @returns 
  */
 const addUpdateCollection = async ({name, data}) => {
 
     const store = await createtransaction(name, 'readwrite');
     /**
      * Add or update
      * @param {Object} data
      */
     const result = await store.put(data)
 
     return result
 
     // const collection = new Promise((resolve, reject) => {
     //     holesdb.collection(name)
     //     .doc(filter)
     //     .set(data)
     //     .then(res => {
     //         resolve(res);
     //     })
     //     .catch(() => {
     //         holesdb.collection(name)
     //             .add(data)
     //             .then(res => {
     //                 resolve(res)
     //             })
     //             .catch(err => {
     //                 reject(err);
     //             })
     //     })
     // })
 
     // return collection;
 }

 /**
 * Multitple update collection
 */
  const updatecollections = async ({datas, name}) => {
    /**
     * Clean record
     */
    const keyid = stores.find(s => s.name == name)
    if(keyid) {
        const irecord = await getCollections({name : name})
        // console.log('clean record', datas, irecord, keyid.keypath, name)
        cleanrecord(datas, irecord, keyid.keypath, name)
    }

    // add update collections
    datas.forEach(d => {
        addUpdateCollection({name : name,  data : d})
    })
}
 
 /**
  * Update document from collection
  * this same as add and update
  * were gonna change this later on
  */
 const updateCollection = async ({name,  data}) => {
     const result = await addUpdateCollection({name, data})
     return result;
     // const collection = new Promise((resolve, reject) => {
     //     holesdb.collection(name)
     //     .doc(filter)
     //     .set(data)
     //     .then(res => {
     //         resolve(res);
     //     })
     //     .catch((err) => {
     //         reject(err);
     //     })
     // })
 
     // return collection;
 }
 
 
 /**
  * Override collection
  */
 const overridecollection = async ({name, data}) => {
 
     //clean documents and put new data
     const tx = await createtransaction(name, 'readwrite');
     tx.clear();
 
     /**
      * Add new data
      */
 
     for (let index = 0; index < data.length; index++) {
         const d = data[index];
 
         await tx.put(d)
     }
 
     return data;
     // const newpromise = new Promise((resolve, reject) => {
     //     holesdb.collection(name)
     //         .set(data)
     //         .then(res => {
     //             resolve(res)
     //         })
     //         .catch(err => {
     //             reject(err)
     //         })
     // })
 
     // return newpromise;
 }
 
 /**
  * Delete document from collection
  */
 const deleteCollection = async ({name, filter}) => {
     const tx = await createtransaction(name, 'readwrite');
     if(filter) {
         return tx.delete(filter.id);
 
         // holesdb.collection(name)
         //     .doc(filter)
         //     .delete();
     } else {
         return tx.clear();
         // holesdb.collection(name).delete();
     }
 }
 
 /**
  * Clean up record
  * Match 2 records and get the difference then remove from indexed db
  * @param {Array} newrecord
  * @param {Array} oldrecord
  * @param {String} property // property to check
  * @param {String} collname // collection to clean
  */
  const cleanrecord = async (newrecord = [], oldrecord = [], property, collname) => {
 
     const properties = newrecord.map(n => n[property]);
     const trash      = oldrecord.filter(o => !properties.includes(o[property]));
     
     for (let index = 0; index < trash.length; index++) {
         const  t         = trash[index];
         let    filter    = {};
         filter[property] = t[property]
 
         deleteCollection({name : collname, filter : filter});
         
     }
 }
 
 
 export {
     newJob, 
     getJobs, 
     getJob, 
     deleteJob, 
     getCollections, 
     getCollection, 
     addUpdateCollection, 
     updateCollection, 
     deleteCollection,
     overridecollection,
     updatecollections, 
     cleanrecord
 }